import LogoutModal from "@app/components/logout-modal";
import MenuLinkItem from "@app/components/menu-link-item";
import { MenuLabel, RoutePath } from "@app/constants";
import { MenuList } from "@app/constants/sidebar";
import LogoutIcon from "@app/icons/logout";
import { openPortalDialog } from "@app/services/modal.service";
import { clearUser, selectAuth } from "@app/store/auth";
import { clearLocalStorage } from "@app/utils/util";
import { Images } from "@assets/images";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [isExpandMenu, setIsExpandMenu] = useState(true);

  const userInfo = useSelector(selectAuth);

  useEffect(() => {
    switch (true) {
      case location.pathname.includes(RoutePath.BOOK_MANAGEMENT):
        setTitle(MenuLabel.BOOK_MANAGEMENT);
        break;
      case location.pathname.includes(RoutePath.BANK_MANAGEMENT):
        setTitle(MenuLabel.BANK_MANAGEMENT);
        break;
      case location.pathname.includes(RoutePath.VOICE_TRAIN_MANAGEMENT):
        setTitle(MenuLabel.VOICE_TRAIN_MANAGEMENT);
        break;
      case location.pathname.includes(RoutePath.WALLET_MANAGEMENT):
        setTitle(MenuLabel.WALLET_MANAGEMENT);
        break;
      case location.pathname.includes(RoutePath.WITHDRAW_MANAGEMENT):
        setTitle(MenuLabel.WITHDRAW_MANAGEMENT);
        break;
      case location.pathname.includes(RoutePath.FAQ_MANAGEMENT):
        setTitle(MenuLabel.FAQ_MANAGEMENT);
        break;
      default:
        setTitle("");
        break;
    }
  }, [location]);

  const renderMenu = () => {
    if (!MenuList.length) return;

    return MenuList.map((item, index) => {
      return (
        <MenuLinkItem
          key={index}
          linkTo={item.linkTo}
          icon={item.icon}
          label={isExpandMenu ? item.label : ""}
        />
      );
    });
  };

  const onLogoClick = () => {
    navigate(`/${RoutePath.BOOK_MANAGEMENT}`);
  };

  const onLogoutClick = () => {
    const logoutModalObs = openPortalDialog(LogoutModal);

    logoutModalObs.afterClosed().subscribe((data) => {
      if (data?.isAccept) {
        clearLocalStorage();
        dispatch(clearUser());
        navigate(RoutePath.SIGN_IN);
      }
    });
  };

  const handleExpandMenu = () => {
    setIsExpandMenu((pre) => !pre);
  };

  const handleAvatarClick = () => {
    navigate(RoutePath.ACCOUNT_INFO);
  };

  return (
    <div className="bg-color w-full h-screen">
      <div
        className={clsx(
          `sticky top-0 left-0 w-full h-[100px] bg-white ${isExpandMenu ? "pl-[280px]" : "pl-[110px]"}`
        )}
      >
        <div className="pl-[48px] pr-12 py-5 h-full flex justify-between items-center">
          <div className="font-medium text-[#343C6A] text-[28px]">{title}</div>
          <div>
            <div
              className="w-12 h-12 rounded-full cursor-pointer"
              onClick={handleAvatarClick}
            >
              {!!userInfo.id && (
                <img
                  className="w-12 h-12 rounded-full object-cover"
                  alt=""
                  src={userInfo.thumbnail}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={clsx(
          `h-[calc(100vh-100px)] overflow-y-auto ${isExpandMenu ? "ml-[280px]" : "ml-[110px]"}`
        )}
      >
        <Outlet />
      </div>
      <div
        className={clsx(
          `fixed top-0 left-0 h-screen bg-white ${isExpandMenu ? "w-[280px]" : "w-[110px]"}`
        )}
      >
        <div className="mt-[34px] flex justify-between items-center gap-[11px] px-[25px]">
          <img
            className="cursor-pointer w-28"
            src={Images.LogoText.default}
            alt=""
            onClick={onLogoClick}
          />
          <img
            className="text-red-300 w-[28px] cursor-pointer p-[9px] bg-[#EFF1F9] rounded-[18px]"
            src={
              isExpandMenu
                ? Images.ArrowLeft.default
                : Images.ArrowRight.default
            }
            alt=""
            onClick={handleExpandMenu}
          />
        </div>
        <div
          className={clsx(
            "mt-16 w-full px-[25px] flex flex-col h-[calc(100vh-220px)] justify-between overflow-y-auto",
            {
              "px-[23px]": !isExpandMenu,
            }
          )}
        >
          <div className="flex flex-col gap-5">{renderMenu()}</div>
        </div>
        <div
          className={clsx(
            `fixed bottom-0 z-10 bg-white px-[25px] pb-[25px] ${isExpandMenu ? "w-[280px]" : "w-[110px]"}`
          )}
        >
          <div
            className="h-14 px-5 flex items-center rounded-xl hover:bg-[#6f87ff] cursor-pointer [&_.label]:hover:text-white [&_.fill]:hover:fill-white [&_.stroke]:hover:stroke-white"
            onClick={onLogoutClick}
          >
            <div className="mr-4">
              <LogoutIcon />
            </div>
            <div className="label tracking-[0.024px]">
              {isExpandMenu && "Đăng xuất"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
